import { localStorageInstance } from '@/modules/localStorage'
import { API_URL } from '@/modules/shared/constants/API_URL'
import { httpCodes } from '@/modules/shared/constants/httpCodes'
import { authRouteNames } from '@/ui/routes/routesNames/authRouteNames'

import { Session } from '../domain/models/Session'

type Data = Session
let lastResponse: null | Response = null
let lastJson: null | Data = null
let lastTime = 0
let isRefreshing = false

export default {
  refresh: async function (token: string) {
    if (isRefreshing)
      return await new Promise<Data>((resolve) => {
        const interval = setInterval(() => {
          if (!lastResponse || isRefreshing) return
          clearInterval(interval)
          resolve(lastJson!)
        }, 500)
      })
    isRefreshing = true

    if (!lastResponse || !lastJson || Date.now() > lastTime + 5_000) {
      lastResponse = await fetch(`${API_URL}/v1/token/refresh/`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'X-CompanyID': String(localStorageInstance.getPersona()?.companyId),
          'X-PersonaID': String(localStorageInstance.getPersona()?.personaId),
          'X-PersonaType': String(
            localStorageInstance.getPersona()?.personaType
          )
        },
        cache: 'reload'
      })

      if (
        lastResponse.status === httpCodes.FORBIDDEN ||
        lastResponse.status === httpCodes.UNAUTHORIZED
      ) {
        localStorageInstance.deleteUser()
        localStorageInstance.deletePersona()
        localStorageInstance.clear()
        location.pathname = authRouteNames.login
      }

      lastJson = await lastResponse.json()
      lastTime = Date.now()
    }

    isRefreshing = false
    return lastJson!
  }
}
